import { createRouteGuard } from "./router/helper";
import "@/config/rem";
export function useGlobal(): void {
  createRouteGuard();
}
